import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_NUMBER = "GET_LIST_NUMBER";
export const GET_LIST_NUMBER_ERROR = "GET_LIST_NUMBER_ERROR";
export const GET_LIST_NUMBER_SUCCESS = "GET_LIST_NUMBER_SUCCESS";

export const EDIT_NUMBER = "EDIT_NUMBER";
export const EDIT_NUMBER_ERROR = "EDIT_NUMBER_ERROR";
export const EDIT_NUMBER_SUCCESS = "EDIT_NUMBER_SUCCESS";

export const COUNT_NUMBER = "COUNT_NUMBER";
export const COUNT_NUMBER_ERROR = "COUNT_NUMBER_ERROR";
export const COUNT_NUMBER_SUCCESS = "COUNT_NUMBER_SUCCESS";

export const GET_NUMBER_DEFAULT = "GET_NUMBER_DEFAULT";
export const GET_NUMBER_DEFAULT_SUCCESS = "GET_NUMBER_DEFAULT_SUCCESS";
export const GET_NUMBER_DEFAULT_ERROR = "GET_NUMBER_DEFAULT_ERROR";

export const SET_NUMBER_DEFAULT = "SET_NUMBER_DEFAULT";
export const SET_NUMBER_DEFAULT_SUCCESS = "SET_NUMBER_DEFAULT_SUCCESS";
export const SET_NUMBER_DEFAULT_ERROR = "SET_NUMBER_DEFAULT_ERROR";

/**
 * Reducer
 */

const initialState = {
  phoneNumbers: [],
  error: false,
  count: 0,
  loading: false,
  results: [],
  result: {},
};

export const phoneNumberReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_NUMBER:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        phoneNumbers: action.payload,
      };
    case GET_LIST_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //edit phone
    case EDIT_NUMBER:
      return {
        ...state,
      };
    case EDIT_NUMBER_SUCCESS:
      return {
        ...state,
      };
    case EDIT_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //count list
    case COUNT_NUMBER:
      return {
        ...state,
      };
    case COUNT_NUMBER_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_NUMBER_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //number default
    case GET_NUMBER_DEFAULT:
      return {
        ...state,
      };
    case GET_NUMBER_DEFAULT_SUCCESS:
      return {
        ...state,
        results: action.payload,
      };
    case GET_NUMBER_DEFAULT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //set default
    case SET_NUMBER_DEFAULT:
      return {
        ...state,
      };
    case SET_NUMBER_DEFAULT_SUCCESS:
      return {
        ...state,
        result: action.payload,
      };
    case SET_NUMBER_DEFAULT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
};

/**
 * Action
 */
export const getListPhoneNumber = (order, limit, skip, where, contactCode) => ({
  type: GET_LIST_NUMBER,
  data: {
    order,
    limit,
    skip,
    where,
    contactCode,
  },
});

export const editPhoneNumber = (id, data) => ({
  type: EDIT_NUMBER,
  data: {
    id,
    data,
  },
});

export const countNumber = (where) => ({
  type: COUNT_NUMBER,
  data: {
    where,
  },
});

export const getNumberDefault = (order, limit, skip, where) => ({
  type: GET_NUMBER_DEFAULT,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const setDefaultNumber = (numberId) => ({
  type: SET_NUMBER_DEFAULT,
  data: {
    numberId,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListPhoneNumber,
      countNumber,
      setDefaultNumber,
      getNumberDefault,
      editPhoneNumber,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListApi = (order, limit, skip, where, contactCode) => {
  let query = [];
  if (contactCode) {
    query.push(`contactCode=${contactCode}`);
  }
  return apiCaller.getLogs(`/cloud-pbx/number?${query.join("&")}`, {
    order,
    limit,
    skip,
    ...where,
  });
};

const editPhoneApi = (id, data) => {
  return apiCaller.putRequest("/cloud-pbx/number/" + id, { ...data });
};

const countNumberApi = (where) => {
  return apiCaller.getData("/cloud-pbx/number/count", { ...where });
};

const getNumberDefaultApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/cloud-pbx/number-default", {
    order,
    limit,
    skip,
    ...where,
  });
};

const setNumberDefaultApi = (numberId) => {
  return apiCaller.post("/cloud-pbx/number-default/update-default-number", {
    numberId,
  });
};
/**
 * sagas
 */

export const getListFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_NUMBER);
    try {
      const res = yield call(
        getListApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.contactCode
      );
      yield put({ type: GET_LIST_NUMBER_SUCCESS, payload: [...res.data] });
    } catch (error) {
      yield put({ type: GET_LIST_NUMBER_ERROR, error });
    }
  }
};

export const countNumberFlow = function* () {
  while (true) {
    const action = yield take(COUNT_NUMBER);
    try {
      const res = yield call(countNumberApi, action.data.where);
      yield put({ type: COUNT_NUMBER_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_NUMBER_ERROR, error });
    }
  }
};

export const getNumberDefaultFlow = function* () {
  while (true) {
    const action = yield take(GET_NUMBER_DEFAULT);
    try {
      const res = yield call(
        getNumberDefaultApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_NUMBER_DEFAULT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_NUMBER_DEFAULT_ERROR, error });
    }
  }
};

export const setNumberDefaultFlow = function* () {
  while (true) {
    const action = yield take(SET_NUMBER_DEFAULT);
    try {
      const res = yield call(setNumberDefaultApi, action.data.numberId);
      yield put({ type: SET_NUMBER_DEFAULT_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: SET_NUMBER_DEFAULT_ERROR, error });
    }
  }
};

export const editNumberFlow = function* () {
  while (true) {
    const action = yield take(EDIT_NUMBER);
    try {
      const res = yield call(editPhoneApi, action.data.id, action.data.data);
      yield put({ type: EDIT_NUMBER_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_NUMBER_ERROR, error });
    }
  }
};
